export interface PublicFirebaseConfig {
  readonly apiKey: string;
  readonly authDomain: string;
  readonly databaseURL: string;
  readonly projectId: string;
  readonly storageBucket: string;
  readonly messagingSenderId: string;
  readonly appId: string;
}

export const PUBLIC_FIREBASE_CONFIG: PublicFirebaseConfig = Object.freeze({
  apiKey: 'AIzaSyCX0hRuNhicZ1dwxTX3YlW_BQBgnS2e50E',
  authDomain: 'yugioh-slot.firebaseapp.com',
  databaseURL: 'https://yugioh-slot-default-rtdb.europe-west1.firebasedatabase.app/',
  projectId: 'yugioh-slot',
  storageBucket: 'yugioh-slot.firebasestorage.app',
  messagingSenderId: '581446716788',
  appId: '1:581446716788:web:d8dee9ab56ca73bdd3b021',
});

export const FIREBASE_PATHS = Object.freeze({
  chatMessages: 'globalChat/messages',
  seasonXRuns: 'leaderboards/seasons/seasonx/globalRuns/entries',
  seasonXFreeSpins: 'leaderboards/seasons/seasonx/freeSpins/entries',
  seasonXReplays: 'leaderboards/seasons/seasonx/freeSpins/replays',
  seasonXExtremeRuns: 'leaderboards/seasons/seasonx/extreme/runs/entries',
  seasonXExtremeFreeSpins: 'leaderboards/seasons/seasonx/extreme/freeSpins/entries',
  seasonXExtremeReplays: 'leaderboards/seasons/seasonx/extreme/freeSpins/replays',
});

export type FirebaseEnvironment = Readonly<Record<string, string | boolean | undefined>>;

export function firebaseIsDisabled(environment: FirebaseEnvironment = import.meta.env): boolean {
  const value = environment.VITE_FIREBASE_DISABLED;
  return value === true || value === 'true' || value === '1';
}

/** Public browser credentials may be overridden for local/emulator deployments. */
export function resolveFirebaseConfig(
  environment: FirebaseEnvironment = import.meta.env,
): PublicFirebaseConfig {
  const value = (key: string, fallback: string): string => {
    const candidate = environment[key];
    return typeof candidate === 'string' && candidate.trim() ? candidate.trim() : fallback;
  };
  return Object.freeze({
    apiKey: value('VITE_FIREBASE_API_KEY', PUBLIC_FIREBASE_CONFIG.apiKey),
    authDomain: value('VITE_FIREBASE_AUTH_DOMAIN', PUBLIC_FIREBASE_CONFIG.authDomain),
    databaseURL: value('VITE_FIREBASE_DATABASE_URL', PUBLIC_FIREBASE_CONFIG.databaseURL),
    projectId: value('VITE_FIREBASE_PROJECT_ID', PUBLIC_FIREBASE_CONFIG.projectId),
    storageBucket: value('VITE_FIREBASE_STORAGE_BUCKET', PUBLIC_FIREBASE_CONFIG.storageBucket),
    messagingSenderId: value('VITE_FIREBASE_MESSAGING_SENDER_ID', PUBLIC_FIREBASE_CONFIG.messagingSenderId),
    appId: value('VITE_FIREBASE_APP_ID', PUBLIC_FIREBASE_CONFIG.appId),
  });
}

export function isValidFirebaseDatabaseUrl(value: string): boolean {
  try {
    const url = new URL(value);
    return url.protocol === 'https:'
      && (url.hostname.endsWith('.firebasedatabase.app') || url.hostname.endsWith('.firebaseio.com'));
  } catch {
    return false;
  }
}
